<div class="w-100 customersearch-forms p-0">
  <div class="col-12 p-0 mt-3 mb-2">
    <div class="d-flex justify-content-end align-items-end">
      <a href="javascript:void(0)" (click)="openAccountModal()" class="add-account-link">{{ 'atgUserManagement.list.addAccount' | cxTranslate }}</a>
    </div>
  </div>

  <div class="col-12 p-0">
    <!-- Selected Accounts List -->
    <div class="selected-accounts-section" *ngIf="selectedAccounts.length > 0">
      <h6 class="section-title">{{ 'atgUserManagement.list.selectedAccounts' | cxTranslate }}</h6>
      <div class="accounts-table-wrapper">
        <table class="table table-striped table-bordered accounts-table">
          <thead class="table-header">
            <tr>
              <th class="col-account-group">{{ 'atgUserManagement.list.accountGroup' | cxTranslate }}</th>
              <th class="col-account-num">{{ 'atgUserManagement.list.accountNumber' | cxTranslate }}</th>
              <th class="col-division">{{ 'atgUserManagement.list.authorizedDivisions' | cxTranslate }}</th>
              <th class="col-account-name">{{ 'atgUserManagement.list.accountName' | cxTranslate }}</th>
              <th class="col-city">{{ 'atgUserManagement.list.city' | cxTranslate }}</th>
              <th class="col-state">{{ 'atgUserManagement.list.state' | cxTranslate }}</th>
              <th class="col-zip">{{ 'atgUserManagement.list.zipCode' | cxTranslate }}</th>
              <th class="col-delete text-center">{{ 'atgUserManagement.list.deleteAccounts' | cxTranslate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let account of selectedAccounts; let i = index">
              <td [attr.data-label]="'atgUserManagement.list.accountGroup' | cxTranslate">{{ account.accountGroup }}</td>
              <td [attr.data-label]="'atgUserManagement.list.accountNumber' | cxTranslate">{{ account.accountNumber }}</td>
              <td [attr.data-label]="'atgUserManagement.list.authorizedDivisions' | cxTranslate">{{ getDivisionLabels(account.division) }}</td>
              <td [attr.data-label]="'atgUserManagement.list.accountName' | cxTranslate">{{ account.accountName }}</td>
              <td [attr.data-label]="'atgUserManagement.list.city' | cxTranslate">{{ account.city }}</td>
              <td [attr.data-label]="'atgUserManagement.list.state' | cxTranslate">{{ account.state }}</td>
              <td [attr.data-label]="'atgUserManagement.list.zipCode' | cxTranslate">{{ account.zipCode }}</td>
              <td class="text-center" [attr.data-label]="'atgUserManagement.list.deleteAccounts' | cxTranslate">
                <input type="checkbox" [(ngModel)]="account.markedForDelete" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="accounts-actions d-flex justify-content-end" *ngIf="getMarkedForDeleteCount() > 0">
        <button type="button" class="btn btn-danger btn-sm" (click)="deleteSelectedAccounts()">
          {{ 'atgUserManagement.list.deleteCount' | cxTranslate: { count: getMarkedForDeleteCount() } }}
        </button>
      </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state text-center" *ngIf="selectedAccounts.length === 0">
      <p class="text-muted">{{ 'atgUserManagement.list.emptyState' | cxTranslate }}</p>
    </div>
  </div>


<!-- Account Search Modal -->
<div class="modal fade" [class.show]="showAccountModal" [style.display]="showAccountModal ? 'block' : 'none'" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content" [style.max-height]="'calc(100vh - 60px)'" [style.display]="'flex'" [style.flex-direction]="'column'" [style.position]="'relative'">

      <!-- Search loader — .overlay triggers Spartacus's built-in absolute+flex positioning -->
      <cx-spinner *ngIf="isSearching" class="overlay"></cx-spinner>

      <div class="modal-header">
        <div class="modal-header-content">
          <h5 class="modal-title">{{ 'atgUserManagement.list.searchForAccounts' | cxTranslate }}</h5>
          <p>{{ 'atgUserManagement.list.searchCriteriaHint' | cxTranslate }}</p>
        </div>
      </div>

      <div class="modal-body" [style.flex]="'1'" [style.overflow-y]="'auto'" [style.min-height]="'0'">
        <form [formGroup]="searchForm" class="search-form">

          <!-- Row 1: Division | Account Name | Account# -->
          <div class="row">
            <div class="col-12 col-sm-6 col-md-3">
              <div class="form-group notched-group">
                <label class="text-muted notched-label">{{ 'atgUserManagement.list.atgDivision' | cxTranslate }} <span class="text-danger">*</span></label>
                <div class="select-wrapper ng-select-wrapper" [class.is-invalid]="searchForm.get('division')?.invalid && searchForm.get('division')?.touched">
                  <ng-select
                    [items]="divisions"
                    formControlName="division"
                    bindLabel="label"
                    bindValue="value"
                    [searchable]="false"
                    [clearable]="false"
                    class="w-100"
                  >
                  </ng-select>
                  <span class="custom-placeholder" *ngIf="!searchForm.get('division')?.value">{{ 'atgUserManagement.list.atgDivision' | cxTranslate }}</span>
                </div>
                <div class="invalid-feedback d-block" *ngIf="searchForm.get('division')?.invalid && searchForm.get('division')?.touched">
                  {{ 'atgUserManagement.list.divisionRequired' | cxTranslate }}
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <div class="form-group notched-group">
                <label class="text-muted notched-label">{{ 'atgUserManagement.list.accountName' | cxTranslate }}</label>
                <input type="text" class="form-control" [placeholder]="'atgUserManagement.list.accountName' | cxTranslate" formControlName="accountName" />
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <div class="form-group notched-group">
                <label class="text-muted notched-label">{{ 'atgUserManagement.list.accountNumber' | cxTranslate }}</label>
                <input type="text" class="form-control" [placeholder]="'atgUserManagement.list.accountNumber' | cxTranslate" formControlName="accountNumber" />
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <div class="form-group notched-group">
                <label class="text-muted notched-label">{{ 'atgUserManagement.list.accountType' | cxTranslate }} <span class="text-danger">*</span></label>
                <div class="select-wrapper ng-select-wrapper" [class.is-invalid]="searchForm.get('accountType')?.invalid && searchForm.get('accountType')?.touched">
                  <ng-select
                    [items]="accountTypes"
                    formControlName="accountType"
                    bindLabel="label"
                    bindValue="value"
                    [placeholder]="'atgUserManagement.list.selectAccountType' | cxTranslate"
                    [searchable]="false"
                    [clearable]="false"
                    class="w-100"
                  >
                  </ng-select>
                </div>
                <div class="invalid-feedback d-block" *ngIf="searchForm.get('accountType')?.invalid && searchForm.get('accountType')?.touched">
                  {{ 'atgUserManagement.list.accountTypeRequired' | cxTranslate }}
                </div>
              </div>
            </div>
          </div>

          <!-- Row 2: Account Type | City | Country -->
          <div class="row">
            <div class="col-12 col-sm-6 col-md-3">
              <div class="form-group notched-group">
                <label class="text-muted notched-label">{{ 'atgUserManagement.list.city' | cxTranslate }}</label>
                <input type="text" class="form-control" [placeholder]="'atgUserManagement.list.city' | cxTranslate" formControlName="city" />
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <div class="form-group notched-group">
                <label class="text-muted notched-label">{{ 'atgUserManagement.list.country' | cxTranslate }}</label>
                <div class="select-wrapper ng-select-wrapper">
                  <ng-select
                    [items]="countries$ | async"
                    formControlName="country"
                    bindLabel="name"
                    bindValue="isocode"
                    [loading]="isCountryLoading"
                    [searchable]="true"
                    [clearable]="false"
                    class="w-100"
                  >
                  </ng-select>
                  <span class="custom-placeholder" *ngIf="!searchForm.get('country')?.value">{{ 'atgUserManagement.list.selectCountry' | cxTranslate }}</span>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <div class="form-group notched-group">
                <label class="text-muted notched-label">{{ 'atgUserManagement.list.state' | cxTranslate }}</label>
                <div class="select-wrapper ng-select-wrapper">
                  <ng-select
                    [items]="(states$ | async) || []"
                    formControlName="state"
                    bindLabel="name"
                    bindValue="isocode"
                    [loading]="isStateLoading"
                    [readonly]="!isStateLoading && !(states$ | async)?.length"
                    [searchable]="true"
                    [clearable]="false"
                    class="w-100"
                  >
                  </ng-select>
                  <span class="custom-placeholder" *ngIf="!searchForm.get('state')?.value">{{ 'atgUserManagement.list.selectState' | cxTranslate }}</span>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <div class="form-group notched-group">
                <label class="text-muted notched-label">{{ 'atgUserManagement.list.zipCode' | cxTranslate }}</label>
                <input type="text" class="form-control" [placeholder]="'atgUserManagement.list.zipCode' | cxTranslate" formControlName="zipCode" />
              </div>
            </div>
          </div>
          <!-- Action buttons -->
          <div class="row mb-0">
            <div class="col-12 form-actions">
              <button type="button" class="btn btn-sm btn-primary" (click)="onSearch()" [disabled]="isSearching">{{ 'atgUserManagement.list.search' | cxTranslate }}</button>
              <button type="button" class="btn btn-sm btn-secondary" (click)="resetSearchForm()" [disabled]="isSearching">{{ 'atgUserManagement.list.reset' | cxTranslate }}</button>
            </div>
          </div>

        </form>

        <!-- Search Results Section (outside form to avoid ngModel/formGroup conflict) -->
        <div class="search-results-section" *ngIf="showSearchResults">
          <h6 class="results-title">{{ 'atgUserManagement.list.resultsTitle' | cxTranslate }}</h6>
          <div class="table-wrapper">
            <table class="table table-striped table-bordered results-table">
              <thead class="table-header">
                <tr>
                  <th class="col-account-name">{{ 'atgUserManagement.list.accountName' | cxTranslate }}</th>
                  <th class="col-division">{{ 'atgUserManagement.list.selectAccountDivision' | cxTranslate }}</th>
                  <th class="col-city">{{ 'atgUserManagement.list.city' | cxTranslate }}</th>
                  <th class="col-state">{{ 'atgUserManagement.list.state' | cxTranslate }}</th>
                  <th class="col-zip">{{ 'atgUserManagement.list.zipCode' | cxTranslate }}</th>
                  <th class="col-acct-num">{{ 'atgUserManagement.list.accountNumber' | cxTranslate }}</th>
                  <th class="col-acct-num">{{ 'atgUserManagement.list.accountGroup' | cxTranslate }}</th>
                  <th class="col-add text-center">
                    <input type="checkbox" [checked]="isAllSelected()" (change)="toggleSelectAll($event.target.checked)" [attr.title]="'atgUserManagement.list.selectAll' | cxTranslate" />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let result of searchResults; trackBy: trackByResultId"
                    [class.table-primary]="result.selected">
                  <td>{{ result.accountName }}</td>
                  <td>
                    <ng-select
                      [items]="result.salesAreaItems"
                      [multiple]="true"
                      [closeOnSelect]="false"
                      [searchable]="false"
                      appendTo="body"
                      dropdownClass="division-dropdown"
                      [placeholder]="'atgUserManagement.list.selectDivision' | cxTranslate"
                      [(ngModel)]="result.division"
                      bindLabel="label"
                      bindValue="value"
                      class="custom-ng-select"
                    >
                      <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        <div class="ng-value" *ngIf="items.length === 1">
                          <span class="ng-value-label" [ngbTooltip]="items[0].label" container="body" tooltipClass="division-tooltip">{{ items[0].label }}</span>
                          <span class="ng-value-icon" (click)="clear(items[0])" aria-hidden="true">&times;</span>
                        </div>
                        <div class="ng-value" *ngIf="items.length > 1">
                          <span class="ng-value-label">{{ 'atgUserManagement.list.selectedCount' | cxTranslate: { count: items.length } }}</span>
                        </div>
                      </ng-template>
                      <ng-template ng-header-tmp>
                        <div class="ng-select-header-actions">
                            <a href="javascript:void(0)"
                             (mousedown)="$event.preventDefault()"
                             (click)="selectAllDivisions(result.id)"
                              class="select-action-link">{{ 'atgUserManagement.list.selectAll' | cxTranslate }}</a>
                          <span class="action-divider">|</span>
                          <a href="javascript:void(0)"
                             (mousedown)="$event.preventDefault()"
                             (click)="unselectAllDivisions(result.id)"
                              class="select-action-link">{{ 'atgUserManagement.list.clearAll' | cxTranslate }}</a>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <span class="option-checkbox">
                          <input id="div-{{result.id}}-{{index}}" type="checkbox" [ngModel]="item$.selected" />
                          <span [ngbTooltip]="item.label" container="body" tooltipClass="division-tooltip">{{ item.label }}</span>
                        </span>
                      </ng-template>
                    </ng-select>
                  </td>
                  <td>{{ result.city }}</td>
                  <td>{{ result.state }}</td>
                  <td>{{ result.zipCode }}</td>
                  <td>{{ result.accountNumber }}</td>
                  <td>{{ result.accountGroup }}</td>
                  <td class="text-center">
                    <input type="checkbox" [checked]="result.selected" (change)="toggleAccountSelection(result.id)" />
                  </td>
                </tr>
                <tr *ngIf="searchResults.length === 0">
                  <td colspan="8" class="text-center text-muted py-3">{{ 'atgUserManagement.list.noResults' | cxTranslate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="addSelectedAccounts()" [disabled]="!searchResults.some(r => r.selected && r.division.length > 0)">{{ 'atgUserManagement.list.addAccount' | cxTranslate }}</button>
        <button type="button" class="btn btn-secondary" (click)="closeAccountModal()">{{ 'atgUserManagement.list.close' | cxTranslate }}</button>
      </div>

    </div>
  </div>
</div>

<!-- Modal Backdrop -->
<div class="modal-backdrop fade" [class.show]="showAccountModal" *ngIf="showAccountModal"></div>

<!-- Account Details Modal -->
<div class="modal fade" [class.show]="showAccountDetailsModal" [style.display]="showAccountDetailsModal ? 'block' : 'none'" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content" *ngIf="selectedAccountDetails">
      <div class="modal-header">
        <h5 class="modal-title">{{ selectedAccountDetails.accountName }}</h5>
        <button type="button" class="btn-close" (click)="closeAccountDetailsModal()"></button>
      </div>
      <div class="modal-body">
        <div class="account-details">
          <div class="row mb-3">
            <div class="col-md-6">
              <p><strong>Account Number:</strong> {{ selectedAccountDetails.accountNumber }}</p>
            </div>
            <div class="col-md-6">
              <p><strong>City:</strong> {{ selectedAccountDetails.city }}</p>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <p><strong>State:</strong> {{ selectedAccountDetails.state }}</p>
            </div>
            <div class="col-md-6">
              <p><strong>Country:</strong> {{ selectedAccountDetails.country }}</p>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <p><strong>{{ 'atgUserManagement.list.zipCode' | cxTranslate }}:</strong> {{ selectedAccountDetails.zipCode }}</p>
            </div>
          </div>

          <div class="mt-4" *ngIf="selectedAccountDetails.salesAreaList && selectedAccountDetails.salesAreaList.length > 0">
            <h6>{{ 'atgUserManagement.list.authorizedDivisions' | cxTranslate }}</h6>
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th>{{ 'atgUserManagement.list.divisionCode' | cxTranslate }}</th>
                  <th>{{ 'atgUserManagement.list.divisionName' | cxTranslate }}</th>
                  <th>{{ 'atgUserManagement.list.salesArea' | cxTranslate }}</th>
                  <th class="text-center">{{ 'atgUserManagement.list.selected' | cxTranslate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let salesArea of selectedAccountDetails.salesAreaList">
                  <td>{{ salesArea.accountCode }}</td>
                  <td>{{ salesArea.accountName }}</td>
                  <td>{{ salesArea.salesArea }}</td>
                  <td class="text-center">
                    <span *ngIf="selectedAccountDetails.division.includes(salesArea.accountCode)" class="badge bg-success">
                      ✓
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeAccountDetailsModal()">{{ 'atgUserManagement.list.close' | cxTranslate }}</button>
      </div>
    </div>
  </div>
</div>

<!-- Account Details Modal Backdrop -->
<div class="modal-backdrop fade" [class.show]="showAccountDetailsModal" *ngIf="showAccountDetailsModal"></div>
